module.exports = __webpack_public_path__ + "static/media/cafeswap.7750605e.png";